import React, { Component } from "react";
import styles from "./ZhiboFloor.module.css";

import { getLiveInfoByVendorId } from "../../api";
import QRCode from 'qrcode.react';

interface ZhiboFloorProps {
  venderId: Number;
}
interface ZhiboFloorState {
  liveInfo: any;
  isShowQrCode: boolean
}

class ZhiboFloor extends Component<ZhiboFloorProps, ZhiboFloorState> {
  constructor(props: ZhiboFloorProps) {
    super(props)
    this.state = {
      liveInfo: '',
      isShowQrCode: false
    }
  }

  componentDidMount() {
    const {venderId} = this.props
    getLiveInfoByVendorId({ vendorId: venderId }).then((res: any) => {
      if (res && res.data && JSON.stringify(res.data) !== "{}") {
        this.setState({
          liveInfo: res.data
        })
      }
    })
  }

  handleIsShowQrCode = (bool: boolean) => {
    this.setState({
      isShowQrCode: bool
    })
  }

  getStatusTxt = (status:number)=>{
    let statusTxt = ''
    if(status===0){
      statusTxt = '预告'
    }else if(status===1){
      statusTxt = '直播中'
    }else if(status===3){
      statusTxt = '回放'
    }
    return statusTxt
  }

  render() {
    const { liveInfo, isShowQrCode } = this.state
    const { squareIndexImage, productList, title, openApp,status } = liveInfo
    return (
      <React.Fragment>
        {liveInfo &&
          <div className={styles.pm_live_entry}>
            <div
              className={styles.live_main}
            >
              <img
                src={`${squareIndexImage}!q80!cc_726x230`}
                width="726"
                height="230"
                onMouseEnter={() => {
                  this.handleIsShowQrCode(true)
                }}
              />
              <div className={[styles.live_status, styles[`live_status_${status}`]].join(' ')}>
                <div className={styles.live_status_icon}></div>
                <div className={styles.live_status_text}>{this.getStatusTxt(status)}</div>
              </div>
              {!isShowQrCode && <div className={styles.live_play}></div>}
              {isShowQrCode &&
                <div>
                  <div
                    className={styles.live_qrcode}
                    onMouseLeave={() => {
                      this.handleIsShowQrCode(false)
                    }}
                  >
                    <div className={styles.qrcode_canvas}>
                    <QRCode
                      value={openApp}
                      size={112}
                    />
                  </div>
                  <div className={styles.qrcode_text}>京东APP扫码查看精彩{status===3?'回放':'直播'}</div>
                  </div>
                </div>
              }
            </div>

            <div className={styles.live_content}>
              <h3>{title}</h3>
              <h4>APP扫码看直播，观看更多优质拍品。</h4>
              {productList && productList.length > 0 &&
                <ul>
                  {productList.map((val: {paimaiId:number;productImage:string}, index: number) => {
                    return (
                      <li key={index}>
                        <a href={`//paimai.jd.com/${val.paimaiId}`} target="_blank">
                          <img src={`//img10.360buyimg.com/paimai/s144x144_${val.productImage}`} width="144" height="144" />
                        </a>
                      </li>
                    )
                  })}
                </ul>
              }
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

export default ZhiboFloor;